//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'UiProgressLinear',

  props: {
    type: {
      type: String,
      default: 'indeterminate', // 'determinate' or 'indeterminate'
    },
    color: {
      type: String,
      default: 'primary', // 'primary', 'accent', 'black' or 'white'
    },
    progress: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    classes() {
      return [`ui-progress-linear--color-${this.color}`, `ui-progress-linear--type-${this.type}`];
    },

    moderatedProgress() {
      if (this.progress < 0) {
        return 0;
      }

      if (this.progress > 100) {
        return 100;
      }

      return this.progress;
    },
  },
};

